import {Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output, Renderer2} from '@angular/core';
import {CoreService} from './core.service';
import {Subscription} from 'rxjs';

@Directive({
    selector: '[appSidebarToggle]',
    standalone: false
})
export class SidebarToggleDirective implements OnDestroy {
  subscription: Subscription = new Subscription();

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private s: CoreService) {
    this.subscription.add(
      this.s.sidebarOpen$.subscribe(v => {
        const hidden_class = 'sidebar-mini',
          has_hidden_class = document.body.classList.contains(hidden_class);
        if (has_hidden_class && v) {
          this.renderer.removeClass(document.body, hidden_class);
        } else if (!has_hidden_class && !v) {
          this.renderer.addClass(document.body, hidden_class);
        }
      })
    );
    this.s.checkSidebar();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('window:resize', ['$event.target'])
  private onResize(targetElement) {
    this.s.checkSidebar();
  }

}


@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  @Output('appClickOutside') appClickOutside: EventEmitter<any> = new EventEmitter();

  private localEvent = null;

  constructor() {
  }

  @HostListener('click', ['$event'])
  trackEvent(event) {
    this.localEvent = event;
  }

  @HostListener('document:click', ['$event'])
  compareEvent(event) {
    if (event !== this.localEvent) {
      this.appClickOutside.emit(event);
    }
    this.localEvent = null;
  }
}
